module.exports = function(companyType) {
    return companyType === 'ENK' || companyType === 'PMV'
}
